/* Qibla bearing (degrees from true north) from coordinates to the Kaaba —
   a real great-circle computation, never a stored value. Shared by the masjid
   detail and directory "Today at a glance" panels. */
export function qiblaBearing(lat: number, lng: number): number {
  const toRad = (d: number) => (d * Math.PI) / 180
  const toDeg = (r: number) => (r * 180) / Math.PI
  const kLat = toRad(21.4225), kLng = toRad(39.8262)
  const φ = toRad(lat), Δλ = kLng - toRad(lng)
  const y = Math.sin(Δλ)
  const x = Math.cos(φ) * Math.tan(kLat) - Math.sin(φ) * Math.cos(Δλ)
  return (toDeg(Math.atan2(y, x)) + 360) % 360
}

export function compass(bearing: number): string {
  const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']
  return dirs[Math.round(bearing / 45) % 8]
}

/* Representative coordinates for the cities the directory filters by — used to
   compute a city-level Qibla bearing on the directory glance panel. Real
   geographic coordinates; the per-masjid pages always use the masjid's own. */
export const CITY_COORDS: Record<string, [number, number]> = {
  Hyderabad: [17.385, 78.4867],
  Delhi: [28.6139, 77.209],
  Mumbai: [19.076, 72.8777],
  Pune: [18.5204, 73.8567],
  Kolkata: [22.5726, 88.3639],
  Bengaluru: [12.9716, 77.5946],
  Chennai: [13.0827, 80.2707],
  Lucknow: [26.8467, 80.9462],
}
